import { useQuery } from "@tanstack/react-query";
import { AdvisorKeys } from "web_myplann/Api/Advisor/AdvisorKeys";
import { getAgentIdV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useAgentQuery = (id: number | undefined) => {
	return useQuery({
		queryKey: AdvisorKeys.agentDetail(id),
		queryFn: processResponse(() => getAgentIdV2(id!)),
		enabled: id !== undefined,
	});
};
